export function target() {
  return this.module === 'Widget' && this.data.buttonText === '';
}

export function migrate() {
  /**
   * Alguns clientes já possuiam essa prop salva no buscador como uma string vazia,
   * por isso forçamos a alteração para "Reservar" neste caso.
   */
  this.data.buttonText = 'Reservar';
}
